export const REPLACE_LOCATION = 'replace-location';
const replaceLocation = () => ({ type: REPLACE_LOCATION });
export default replaceLocation;
